function forceDownload(link, url, fileName) {
	window.open(url, '_blank');
}

// PRINT PDF
function printPdf(url) {
	const printWindow = window.open(url, '_blank', 'width=800,height=600');
	printWindow.addEventListener('load', function() {
		printWindow.print();
		printWindow.addEventListener('afterprint', function() {
			printWindow.close();
		});
	});
}

// CHAT SAVE PDF
function chatSave() {
	var chatMessagesDiv = document.getElementById("chat-messages");
	var messages = chatMessagesDiv.getElementsByClassName("message");

	var doc = new window.jspdf.jsPDF({
		unit: "pt",
		format: "letter",
		orientation: "portrait",
	});

	doc.setFont("helvetica");
	doc.setFontSize(12);

	doc.setFontSize(16);
	doc.text("Student Story AI - Chat History", 30, 30);
	doc.setFontSize(12);

	// Init y for text
	var yPos = 60;
	const lineHeight = 20;
	const margin = 30;
	const pageHeight = doc.internal.pageSize.height;

	Array.from(messages).forEach((msg) => {
		let prefix = msg.classList.contains("user-message") ? "You: " : "AI: ";
		let text = prefix + msg.textContent;

		// Split into lines to fit w
		let lines = doc.splitTextToSize(
			text,
			doc.internal.pageSize.width - 2 * margin
		);

		// Check if need new pg brk
		if (yPos + lines.length * lineHeight > pageHeight - margin) {
			doc.addPage();
			yPos = margin;
		}

		// Add lines
		lines.forEach((line) => {
			doc.text(line, margin, yPos);
			yPos += lineHeight;
		});

		// spacing between chat msgs
		yPos += lineHeight / 2;
	});

	doc.save("Student_Story_AI_chat_history.pdf");
}

// CHAT PRINT LOGS
function printChat() {
	var divContents = document.getElementById("chat-messages").innerHTML;
	var a = window.open("", "", "height=500, width=500");
	a.document.write(divContents);
	a.document.close();
	a.print();
}

// CHAT SAVE DOCX
async function chatSaveDocx() {
	try {
		const docx = await import("https://unpkg.com/docx@9.1.1/dist/index.mjs");

		var chatMessagesDiv = document.getElementById("chat-messages");
		var messages = chatMessagesDiv.getElementsByClassName("message");

		//console.log("Messages found:", messages.length);
		Array.from(messages).forEach((msg) => {
			//console.log("Message content:", msg.textContent);
		});

		const paragraphs = Array.from(messages).map((msg) => {
			const messageText = msg.textContent.trim();
			const prefix = msg.classList.contains("user-message") ? "You: " : "Agent: ";
			const fullText = prefix + messageText;

			//console.log("Creating paragraph with text:", fullText);

			return new docx.Paragraph({
				children: [
					new docx.TextRun({
						text: fullText,
						size: 24,
						font: "Arial",
					}),
				],
				spacing: {
					after: 200,
				},
			});
		});

		// Add title
		paragraphs.unshift(
			new docx.Paragraph({
				children: [
					new docx.TextRun({
						text: "Student Story AI - Chat History",
						size: 32,
						bold: true,
						font: "Arial",
					}),
				],
				spacing: {
					after: 400,
				},
				alignment: docx.AlignmentType.CENTER,
			})
		);

		// Create doc
		const doc = new docx.Document({
			sections: [{
				properties: {},
				children: paragraphs,
			}, ],
		});

		docx.Packer.toBlob(doc).then((blob) => {
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			a.href = url;
			a.download = "Student_Story_AI_chat_history.docx";
			a.click();
			window.URL.revokeObjectURL(url);
			document.body.removeChild(a);
		});
	} catch (error) {
		console.error("Error loading DOCX library:", error);
	}
}

// RESULT PRINT DIV
function printDiv() {
	var divContents = document.getElementById("result").innerHTML;
	var a = window.open("", "", "height=500, width=500");
	a.document.write(divContents);
	a.document.close();
	a.print();
}

// FLOATING RED FLAG
function addFloatingRedFlagButton() {
	const redFlagButton = document.createElement("div");
	redFlagButton.id = "floating-flag-button";
	redFlagButton.innerHTML = `
		<button class="floating-flag-button" 
				aria-label="Early Warning Indicators"
				role="button"
				tabindex="0">
		<i class="fa-sharp-duotone fa-solid fa-flag" style="--fa-primary-color: #b6b6b6; --fa-secondary-color: #d20000; --fa-secondary-opacity: 1;"></i>
		</button>
	`;

	// Add red flag
	document.body.appendChild(redFlagButton);

	const chatContainer = document.getElementById("chat-container");
	redFlagButton.style.display = chatContainer.classList.contains("active") ?
		"none" :
		"block";

	redFlagButton.addEventListener("click", () => {
		const chatContainer = document.getElementById("chat-container");
		if (!chatContainer.classList.contains("active")) {
			chatContainer.classList.add("active");
			document.body.classList.add("chat-active");
			redFlagButton.style.display = "none";
		}

		const hiddenPrompt =
			"Analyze the dataset for early warning signs and potential red flags that the user needs to be aware of. If red flags are identified you will inform the user of each concerning statement and provide a direct quote. Next you will explain exactly why the statement is concerning and inform them of ways to address the issue.";
		const visibleMessage = "Search the data for early warning indicators 🚩 ";
		sendMessage(hiddenPrompt, visibleMessage);
	});

	const observer = new MutationObserver(() => {
		redFlagButton.style.display = chatContainer.classList.contains("active") ?
			"none" :
			"block";
	});

	observer.observe(chatContainer, {
		attributes: true,
		attributeFilter: ["class"],
	});
}

// HOVER POP / ANALYZE FURTHER
function showFloatingNotification() {
	// Create floating notification pop
	const notification = document.createElement("div");
	notification.id = "floating-notification";
	notification.innerHTML = `
		<div class="notification-content">
		<i class="fa-duotone fa-solid fa-microchip-ai fa-fade"></i>
		<span>Highlight Text to Analyze Further</span>
		<button class="close-notification" aria-label="Close notification">
		<i class="fa-solid fa-xmark"></i>
		</button>
		</div>
	`;

	// Add to document
	document.getElementById("result-header-flex").appendChild(notification);

	const closeButton = notification.querySelector(".close-notification");
	closeButton.addEventListener("click", () => {
		notification.classList.add("fade-out");
		setTimeout(() => {
			notification.remove();
		}, 300);
	});

	// Close when chat open
	const chatContainer = document.getElementById("chat-container");
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.target.classList.contains("active")) {
				const notification = document.getElementById("floating-notification");
				if (notification) {
					notification.classList.add("fade-out");
					setTimeout(() => {
						notification.remove();
					}, 300);
				}
			}
		});
	});

	observer.observe(chatContainer, {
		attributes: true,
		attributeFilter: ["class"],
	});

	// ani in
	setTimeout(() => {
		notification.classList.add("show");
	}, 100);

	// Auto-hide 5s
	setTimeout(() => {
		if (notification && document.getElementById("floating-notification")) {
			notification.classList.add("fade-out");
			setTimeout(() => {
				if (notification && document.getElementById("floating-notification")) {
					notification.remove();
				}
			}, 300);
		}
	}, 5000);
}

// HOVER POPOVER TOOLTIP UPGRADE AND CLOSE FOR OPTIONS / SETTINGS
document.addEventListener("DOMContentLoaded", function() {
	const tooltip = document.querySelector(".upgrade-tooltip");
	const closeButton = document.querySelector(".close-tooltip");
	const strikeElements = document.querySelectorAll(".upgrade-hover");
	let tooltipTimeout;

	if (tooltip) {
		tooltip.classList.add("hidden");

		// Remove listeners
		tooltip.replaceWith(tooltip.cloneNode(true));

		const freshTooltip = document.querySelector(".upgrade-tooltip");
		const freshCloseButton = freshTooltip.querySelector(".close-tooltip");

		strikeElements.forEach((element) => {
			element.addEventListener("mouseenter", (e) => {
				clearTimeout(tooltipTimeout);
				freshTooltip.classList.remove("hidden");
			});

			element.addEventListener("mouseleave", () => {
				tooltipTimeout = setTimeout(() => {
					freshTooltip.classList.add("hidden");
				}, 3000);
			});
		});

		if (freshCloseButton) {
			freshCloseButton.addEventListener("click", function(e) {
				e.stopPropagation();
				freshTooltip.classList.add("hidden");
			});
		}

		// Close w outside click
		document.addEventListener("click", function(e) {
			if (
				!freshTooltip.contains(e.target) &&
				!e.target.classList.contains("upgrade-hover")
			) {
				freshTooltip.classList.add("hidden");
			}
		});

		// Prevent close if click inside
		freshTooltip.addEventListener("click", function(e) {
			e.stopPropagation();
		});
	}
});

//INSERT ICONS TO HEADER - retry x2
document.addEventListener("DOMContentLoaded", function() {
	window.Charts = window.Charts || {};

	// icon insert to header
	function insertHeaderIcons(retryCount = 0, maxRetries = 2) {
		//console.log(
		//`Attempting to insert header icons (attempt ${retryCount + 1} of ${
		//	maxRetries + 1
		//})`
		//);

		const resultHeaderText = document.getElementById("result-header-text");
		// Find v-nav-icons
		const vNavIcons = document.querySelector(".v-nav-icons");

		//console.log("Found elements:", {
		//resultHeaderText: resultHeaderText ? "exists" : "not found",
		//vNavIcons: vNavIcons ? "exists" : "not found",
		//});

		// If neither exists and not reached max retries, retry w delay
		if (!resultHeaderText && !vNavIcons && retryCount < maxRetries) {
			//console.log(
			//	`Required elements not found, retrying in 1000ms (attempt ${
			//	retryCount + 1
			//	}/${maxRetries})`
			//);
			setTimeout(() => insertHeaderIcons(retryCount + 1, maxRetries), 1000);
			return;
		}

		// tooltip styles
		if (!document.getElementById("aria-tooltip-styles")) {
			const tooltipStyles = document.createElement("style");
			tooltipStyles.id = "aria-tooltip-styles";
			tooltipStyles.textContent = `
				.v-icon, #result-header-text a {
					position: relative;
				}
				
				.v-icon[aria-label]:hover::before, 
				#result-header-text a[aria-label]:hover::before {
					content: attr(aria-label);
					position: absolute;
					background: #333;
					color: white;
					font-size: 0.75rem;
					padding: 5px 10px;
					border-radius: 4px;
					white-space: nowrap;
					z-index: 10;
					top: 100%;
					left: 50%;
					transform: translateX(-120%) translateY(-30px);
					opacity: 0;
					transition: opacity 0.2s;
					pointer-events: none;
				}
				
				.v-icon[aria-label]:hover::before,
				#result-header-text a[aria-label]:hover::before {
					opacity: 1;
				}
			`;
			document.head.appendChild(tooltipStyles);
		}

		if (resultHeaderText || vNavIcons) {
			// Look for signed URLs from result-bottom div
			const downloadLinks = document.querySelectorAll(".result-bottom a");
			let printUrl = "#";
			let wordUrl = "#";
			let pdfUrl = "#";
			let urlsFound = false;

			if (downloadLinks.length > 0) {
				// Find URLs based on icon types
				downloadLinks.forEach((link) => {
					if (link.querySelector("i.fa-print")) {
						printUrl = link.href;
						//	console.log("Found print URL:", printUrl);
					}
					if (link.querySelector("i.fa-file-word")) {
						wordUrl = link.href;
						//	console.log("Found word URL:", wordUrl);
					}
					if (link.querySelector("i.fa-file-contract")) {
						pdfUrl = link.href;
						//console.log("Found PDF URL:", pdfUrl);
					}
				});

				// Check if found URLs
				urlsFound = printUrl !== "#" || wordUrl !== "#" || pdfUrl !== "#";
			}

			// If no URLs +not max retries, retry w delay
			if (!urlsFound && retryCount < maxRetries) {
				//console.log(
				//`No URLs found, retrying in 1000ms (attempt ${
				//	retryCount + 1
				//}/${maxRetries})`
				//);
				setTimeout(() => insertHeaderIcons(retryCount + 1, maxRetries), 1000);
				return;
			}

			if (!urlsFound) {
				//console.log(
				//"No download links found after all retries, falling back to onclick handlers"
				//);
				// Fallback to the original onclick for print if URLs aren't found after retries
				let printLink = document.querySelector('a[onclick*="printDiv"]');
				let wordLink = document.querySelector('a[onclick*="chatSaveDocx"]');
				let pdfLink = document.querySelector('a[onclick*="chatSave"]');

				const printOnclick = printLink ?
					printLink.getAttribute("onclick") :
					"printDiv()";
				const wordOnclick = wordLink ?
					wordLink.getAttribute("onclick") :
					"chatSaveDocx()";
				const pdfOnclick = pdfLink ?
					pdfLink.getAttribute("onclick") :
					"chatSave()";

				//console.log(
				//"URLs not found after retries, rendering print icon only:",
				//{ printOnclick }
				//);
			}

			// Insert icons in RESULT header
			if (resultHeaderText) {
				// If found URLs, use href; otherwise only the print icon is displayed
				if (urlsFound) {
					resultHeaderText.innerHTML = `
						<a href="#" onclick="printPdf('${printUrl}'); return false;" aria-label="Print Report" class="header-icon">    
						<i class="fa-duotone fa-solid fa-print" style="--fa-primary-color: #976b33; --fa-secondary-color: #9c7440; font-size: 1.7rem;"></i>
						</a>

						<div class="dl-parent header-icon" aria-label="Download Options">
							<i class="fa-duotone fa-solid fa-file-arrow-down" style="--fa-primary-color: #987d5a; --fa-secondary-color: #9c7440; font-size: 1.7rem;"></i>
							<div class="dl-children">
								<a href="${wordUrl}" download="Student_Story_AI_document.docx" aria-label="Save as Word Doc" class="dl-child" onclick="forceDownload(this, '${wordUrl}', 'Student_Story_AI_document.docx'); return false;">
									<i class="fa-duotone fa-solid fa-file-word" style="----fa-primary-color: #b28d4e; --fa-secondary-color: #ffffff00; font-size: 1.7rem;"></i>
								</a>
								<a href="${pdfUrl}" download="Student_Story_AI_document.pdf" aria-label="Save as PDF" class="dl-child" onclick="forceDownload(this, '${pdfUrl}', 'Student_Story_AI_document.pdf'); return false;">
									<i class="fa-duotone fa-solid fa-file-contract" style="--fa-primary-color: #b28d4e; --fa-secondary-color: #ffffff00; font-size: 1.7rem;"></i>
								</a>
							</div>
						</div>
					`;
				} else {
					// Fallback to onclick handlers only for print icon if no URLs found after retries
					resultHeaderText.innerHTML = `
						<a href="#" onclick="printDiv()" aria-label="Print Report">    
						<i class="fa-duotone fa-solid fa-print" style="--fa-primary-color: #976b33; --fa-secondary-color: #9c7440; font-size: 1.7rem;"></i>
						</a>
						<!-- Word and PDF icons not displayed due to missing URLs after retries -->	
					`;
				}
			}

			// Insert icons
			if (vNavIcons) {
				//console.log("Attempting to prepend icons to v-nav-icons");

				// Create doc fragment to hold icons
				const fragment = document.createDocumentFragment();

				//  print icon
				const printElement = document.createElement("a");
				printElement.href = "#";
				printElement.className = "v-icon";
				printElement.setAttribute("aria-label", "Print Report");
				if (printUrl === "#") {
					printElement.setAttribute("onclick", "printDiv(); return false;");
				} else {
					printElement.setAttribute("onclick", `printPdf('${printUrl}'); return false;`);
				}
				printElement.innerHTML = `<i class="fa-duotone fa-solid fa-print" style="--fa-primary-color: #bca58e; --fa-secondary-color: #b7a792d4; font-size: 1.5rem;"></i>`;
				fragment.appendChild(printElement);

				// Only add Word and PDF if URLs found
				if (urlsFound) {
					// word icon
					const wordElement = document.createElement("a");
					wordElement.href = wordUrl;
					wordElement.className = "v-icon";
					wordElement.setAttribute("aria-label", "Save as Word Doc");
					wordElement.setAttribute("download", "Student_Story_AI_document.docx");
					if (wordUrl === "#") {
						wordElement.setAttribute(
							"onclick",
							"chatSaveDocx(); return false;"
						);
					} else {
						wordElement.setAttribute(
							"onclick",
							`forceDownload(this, '${wordUrl}', 'Student_Story_AI_document.docx'); return false;`
						);
					}
					wordElement.innerHTML = `<i class="fa-duotone fa-regular fa-file-word" style="--fa-primary-color: #b59f89; --fa-secondary-color: #ffffff00; font-size: 1.5rem;"></i>`;
					fragment.appendChild(wordElement);

					// pdf icon
					const pdfElement = document.createElement("a");
					pdfElement.href = pdfUrl;
					pdfElement.className = "v-icon";
					pdfElement.setAttribute("aria-label", "Save as PDF");
					pdfElement.setAttribute("download", "Student_Story_AI_document.pdf");
					if (pdfUrl === "#") {
						pdfElement.setAttribute("onclick", "chatSave(); return false;");
					} else {
						pdfElement.setAttribute(
							"onclick",
							`forceDownload(this, '${pdfUrl}', 'Student_Story_AI_document.pdf'); return false;`
						);
					}
					pdfElement.innerHTML = `<i class="fa-duotone fa-regular fa-file-contract" style="--fa-primary-color: #b59f89; --fa-secondary-color: #ffffff00; font-size: 1.5rem;"></i>`;
					fragment.appendChild(pdfElement);
				}

				const wordCloudElement = document.createElement("a");
				wordCloudElement.href = "#word-cloud-scroll";
				wordCloudElement.className = "v-icon";
				wordCloudElement.setAttribute("aria-label", "Word Cloud");
				wordCloudElement.onclick = function(e) {
					e.preventDefault();
					const wordCloudElement = document.getElementById("word-cloud-scroll");
					if (wordCloudElement) {
						wordCloudElement.scrollIntoView({
							behavior: "smooth"
						});
						setTimeout(function() {
							window.scrollBy({
								top: -100,
								left: 0,
								behavior: "smooth",
							}); // Scroll up 100 px
						}, 1000);
					} else {
						console.log("Word cloud element not found");
					}
					return false;
				};
				wordCloudElement.innerHTML = `<i class="fa-duotone fa-regular fa-cloud-word" style="--fa-primary-color: #b59f89; --fa-secondary-color: #ffffff00; font-size: 1.5rem;"></i>`;
				fragment.appendChild(wordCloudElement);

				const aiChipsElement = document.createElement("a");
				aiChipsElement.href = "#ai-chips-link";
				aiChipsElement.className = "v-icon";
				aiChipsElement.setAttribute("aria-label", "Additional Insights");
				aiChipsElement.onclick = function(e) {
					e.preventDefault();
					const aiChipsElement = document.getElementById("ai-chips-link");
					if (aiChipsElement) {
						aiChipsElement.scrollIntoView({
							behavior: "smooth"
						});
						setTimeout(function() {
							window.scrollBy({
								top: -100,
								left: 0,
								behavior: "smooth",
							}); // Scroll up 100px
						}, 1000);
					} else {
						console.log("AI chips element not found");
					}
					return false;
				};
				aiChipsElement.innerHTML = `<i class="fa-duotone fa-regular fa-lightbulb-on" style="--fa-primary-color: #b59f89; --fa-secondary-color: #ffffff00; font-size: 1.5rem;"></i>`;
				fragment.appendChild(aiChipsElement);

				const chatElement = document.createElement("a");
				chatElement.href = "#";
				chatElement.className = "v-icon";
				chatElement.setAttribute("aria-label", "Chat with Your Documents");
				chatElement.onclick = function(e) {
					e.preventDefault();
					const chatContainer = document.getElementById("chat-container");
					if (chatContainer) {
						chatContainer.classList.add("active");
						document.body.classList.add("chat-active");

						if (typeof focusUserInput === "function") {
							focusUserInput();
						}
					} else {
						console.log("Chat container not found");
					}
					return false;
				};
				chatElement.innerHTML = `<i class="fa-duotone fa-regular fa-comment-dots" style="--fa-primary-color: #b59f89; --fa-secondary-color: #ffffff00; font-size: 1.5rem;"></i>`;
				fragment.appendChild(chatElement);

				vNavIcons.insertBefore(fragment, vNavIcons.firstChild);

				//console.log("Prepended new icons to v-nav-icons");
			}
		} else {
			console.log("Required elements not found after all retries");
		}
	}

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.addedNodes.length) {
				// Look for presentation div
				mutation.addedNodes.forEach((node) => {
					if (
						node.nodeType === 1 &&
						(node.classList.contains("presentation") ||
							node.querySelector(".presentation"))
					) {
						// Store GS URI from meta tag
						/*
						const gsUri = document.querySelector(
						'meta[name="gs-uri"]'
						)?.content;
						if (gsUri) {
						sessionStorage.setItem("gsUri", gsUri);
						}
						*/

						// Show containers immediately but hidden (for dimension calculations)
						const wordCloudContainer = document.querySelector(
							".word-cloud-container"
						);
						if (wordCloudContainer) {
							wordCloudContainer.style.display = "block";
							wordCloudContainer.style.visibility = "hidden";
							wordCloudContainer.style.opacity = "0";
						}

						const cContainer = document.querySelector("div#c");
						if (cContainer) {
							cContainer.setAttribute(
								"style",
								"display: block !important; visibility: hidden !important; opacity: 0 !important; margin: auto; width: 100%; max-width: 1200px;"
							);
						}

						// Insert icons AFTER result content is complete
						insertHeaderIcons();

						// Initialize word cloud while container has dimensions but is hidden
						WordCloud.initialize();

						// Delay revealing until result div is fully visible
						setTimeout(() => {
							if (wordCloudContainer) {
								wordCloudContainer.style.visibility = "visible";
								wordCloudContainer.style.opacity = "1";
							}

							if (cContainer) {
								cContainer.setAttribute(
									"style",
									"display: block !important; visibility: visible !important; opacity: 1 !important; margin: auto; width: 100%; max-width: 1200px;"
								);

								const aiChips = cContainer.querySelector(".ai-chips");
								if (aiChips) {
									aiChips.setAttribute(
										"style",
										"visibility: visible !important; opacity: 1 !important;"
									);
								}
							}
						}, 3500);

						const roleButtons = document.querySelectorAll(
							".word-cloud-role-chip"
						);
						roleButtons.forEach((button) => {
							if (button.style.display === "none") {
								return;
							}

							button.addEventListener("click", function(e) {
								e.preventDefault();

								if (
									this.classList.contains("active") ||
									this.classList.contains("disabled") ||
									WordCloud._isTransitioning
								) {
									return;
								}

								roleButtons.forEach((btn) => btn.classList.remove("active"));

								this.classList.add("active");

								WordCloud.setRoleButtonsEnabled(false);

								WordCloud.generateWordCloud(this.getAttribute("data-role"));
							});
						});

						observer.disconnect();
					}
				});
			}
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	function setupChatOverlayBehavior() {
		const overlay = document.createElement("div");
		overlay.id = "chat-background-overlay";
		overlay.style.cssText = `
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: transparent;
			z-index: 4;
			display: none;
			pointer-events: none;
		`;
		document.body.appendChild(overlay);

		const bodyObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === "class") {
					const body = document.body;
					if (body.classList.contains("chat-active")) {
						//console.log("Chat active - enabling overlay");
						overlay.style.display = "block";
						overlay.style.pointerEvents = "auto";
						// Store current scroll position
						window.chatScrollPosition = window.scrollY;
						document.body.style.overflow = "hidden";
						document.documentElement.style.overflow = "hidden";
					} else {
						//console.log("Chat inactive - disabling overlay");
						overlay.style.display = "none";
						overlay.style.pointerEvents = "none";
						document.body.style.overflow = "";
						document.documentElement.style.overflow = "";
						if (window.chatScrollPosition !== undefined) {
							window.scrollTo(0, window.chatScrollPosition);
						}
					}
				}
			});
		});

		bodyObserver.observe(document.body, {
			attributes: true
		});

		if (document.body.classList.contains("chat-active")) {
			overlay.style.display = "block";
			overlay.style.pointerEvents = "auto";
			document.body.style.overflow = "hidden";
			document.documentElement.style.overflow = "hidden";
		}
	}

	setupChatOverlayBehavior();
});

// Sidebar
document.addEventListener("DOMContentLoaded", function() {
	// Show spacer div prevent jump
	document.getElementById("v-nav-spacer").style.display = "block";

	const toggle = document.querySelector(".v-menu-toggle");
	const menu = document.querySelector(".v-nav-menu");

	toggle.addEventListener("click", function() {
		menu.classList.toggle("open");
	});

	// Mobile submenu
	const dropdowns = document.querySelectorAll(".v-has-sub");

	dropdowns.forEach((item) => {
		item.addEventListener("click", function(e) {
			if (window.innerWidth <= 768) {
				if (
					e.target === item.querySelector("a") ||
					e.target.closest("a") === item.querySelector("a")
				) {
					e.preventDefault();
					e.stopPropagation();
					this.classList.toggle("open");
				}
			}
		});
	});

	// Sidebar toggle
	const sidebarToggle = document.querySelector(".v-sidebar-toggle");
	const sidebar = document.querySelector(".v-sidebar");
	const sidebarClose = document.querySelector(".v-sidebar-close");
	const overlay = document.querySelector(".v-sidebar-overlay");
	const menuToggleLink = document.querySelector(".menu-toggle");

	// open sidebar
	function openSidebar() {
		sidebar.classList.add("open");
		overlay.classList.add("open");
		document.body.style.overflow = "hidden"; // body scroll
	}

	// Open sidebar when clicking gear icon
	sidebarToggle.addEventListener("click", openSidebar);

	// Open sidebar when clicking Menu link
	menuToggleLink.addEventListener("click", function(e) {
		e.preventDefault();
		openSidebar();
	});

	// Close sidebar
	sidebarClose.addEventListener("click", closeSidebar);
	overlay.addEventListener("click", closeSidebar);

	function closeSidebar() {
		//console.log("Closing sidebar");
		sidebar.classList.remove("open");
		overlay.classList.remove("open");
		document.body.style.overflow = ""; // Restore body scroll

		sidebar
			.querySelectorAll(
				".has-sub.open, .v-sidebar-item.has-sub.open, .v-sidebar-item.open"
			)
			.forEach(function(submenu) {
				submenu.classList.remove("open");
				//console.log("Closing submenu", submenu);
			});
	}

	// Sidebar submenu toggle
	const sidebarItems = document.querySelectorAll(".v-sidebar-item.has-sub");

	sidebarItems.forEach((item) => {
		const sidebarLink = item.querySelector(".v-sidebar-link");

		item.addEventListener("click", function(e) {
			if (e.target === sidebarLink || e.target.closest("a") === sidebarLink) {
				e.preventDefault();
				e.stopPropagation();

				const isCurrentlyOpen = this.classList.contains("open");

				sidebarItems.forEach((otherItem) => {
					if (otherItem !== this && otherItem.classList.contains("open")) {
						otherItem.classList.remove("open");
					}
				});

				if (!isCurrentlyOpen) {
					this.classList.add("open");
					this.closest(".v-sidebar-menu").scrollTo({
						top: 0,
						behavior: "smooth",
					});
				} else {
					this.classList.remove("open");
				}
			}
		});

		const submenuItems = item.querySelectorAll(".v-sidebar-submenu a");
		submenuItems.forEach((submenuLink) => {
			submenuLink.addEventListener("click", function(e) {
				const popoverId = this.getAttribute("data-popover");
				if (popoverId) {
					e.preventDefault();
					e.stopPropagation();
					const popover = document.getElementById(popoverId);
					if (popover) {
						popover.showPopover();
					}
				}
			});
		});
	});

	// v-icon popovers
	const navIcons = document.querySelectorAll(".v-icon");

	navIcons.forEach((icon) => {
		icon.addEventListener("click", function(e) {
			e.preventDefault();
			// Get the popover ID from the data-popover attribute
			const popoverId = this.getAttribute("data-popover");
			if (popoverId) {
				// Find the popover element
				const popover = document.getElementById(popoverId);
				if (popover) {
					// Show the popover
					popover.showPopover();
				}
			}
		});
	});

	// popover for sidebar items w/o submenus
	const sidebarLinksWithoutSub = document.querySelectorAll(
		".v-sidebar-item:not(.has-sub) > .v-sidebar-link, .v-sidebar-item-logout > .v-sidebar-link"
	);

	sidebarLinksWithoutSub.forEach((link) => {
		link.addEventListener("click", function(e) {
			const popoverId = this.getAttribute("data-popover");
			if (popoverId) {
				e.preventDefault();
				const popover = document.getElementById(popoverId);
				if (popover) {
					popover.showPopover();
				}
			}
		});
	});

	const dlButtonStyles = document.createElement('style');
	dlButtonStyles.textContent = `
		.header-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			vertical-align: middle;
			margin: 0 6px;
		}
		.dl-parent {
			position: relative;
			cursor: pointer;
		}
			.dl-parent.header-icon {
    display: none !important;
}
		.dl-children {
			position: absolute;
			display: flex;
			flex-direction: column;
			align-items: center;
			left: 50%;
			transform: translateX(-50%);
			top: 100%;
			height: 0;
		=    transition: height 0.3s ease;
			z-index: 20;
			margin-top: 5px;
		}
		.dl-children.open {
			height: 110px; /* Increased height for better spacing */
		}
		.dl-child {
			opacity: 0;
			transform: translateY(-10px);
			transition: opacity 0.3s ease, transform 0.3s ease;
			margin-top: 15px;
			display: block;
		}
		.dl-children.open .dl-child {
			opacity: 1;
			transform: translateY(0);
		}
		.dl-children.open .dl-child:nth-child(2) {
			transition-delay: 0.1s;
		}
		
		/* Fix for tooltips */
		.header-icon[aria-label]:hover::before,
		.dl-child[aria-label]:hover::before {
			z-index: 100;
			opacity: 1;
			pointer-events: none;
		}
		
		/* Ensure tooltip stays visible */
		.dl-child[aria-label]:hover::before {
			top: 50%;
			left: 120%;
			transform: translateY(-50%);
		}
	`;
	document.head.appendChild(dlButtonStyles);

	// dl button
	function initDownloadButtons() {
		document.addEventListener('click', function(e) {
			const dlParent = e.target.closest('.dl-parent');
			if (dlParent) {
				e.preventDefault();
				const dlChildren = dlParent.querySelector('.dl-children');
				if (dlChildren) {
					// Toggle open state
					dlChildren.classList.toggle('open');

					// clicking outside
					const closeDropdown = function(event) {
						if (!dlParent.contains(event.target)) {
							dlChildren.classList.remove('open');
							document.removeEventListener('click', closeDropdown);
						}
					};

					// clicking outside
					if (dlChildren.classList.contains('open')) {
						setTimeout(() => {
							document.addEventListener('click', closeDropdown);
						}, 0);
					}
				}
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initDownloadButtons);
	} else {
		initDownloadButtons();
	}
});